import { useState, useEffect } from 'react'
import { fetchWithCheckAuthorization } from 'utils/fetchWithAuthorization'
import { APIListInsee } from 'interfaces/API'

interface SearchListeInseeReturnProps {
  listInsee: APIListInsee[]
  moreResults: boolean
  error: string | null
}

interface ListeInseeReturnProps extends SearchListeInseeReturnProps {
  loading: boolean
}

export const searchListInsee = async (
  queryString: string
): Promise<SearchListeInseeReturnProps> => {
  let listInsee: APIListInsee[] = []
  let error: string | null = null
  let moreResults: boolean = false

  try {
    const response = await fetchWithCheckAuthorization(
      `/api/agent/codes-postaux/liste-insee?${new URLSearchParams({
        q: queryString,
      })}`
    )
    if (!response.ok) throw Error(response.statusText)
    const json = await response.json()
    listInsee = json.results
    moreResults = json.moreResults
  } catch (err: unknown) {
    error = (err as Error).toString()
  }

  return { listInsee, moreResults, error }
}

const useListInsee = (): ListeInseeReturnProps => {
  const [listInsee, setListInsee] = useState<APIListInsee[]>([])
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [moreResults, setMoreResults] = useState(false)

  const fetchListInsee = async () => {
    try {
      setLoading(true)
      const props = await searchListInsee('')
      setError(props.error)
      setListInsee(props.listInsee)
      setMoreResults(props.moreResults)
    } catch (err: unknown) {
      console.error(err)
      setError((err as Error).toString())
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchListInsee()
  }, [])

  return { listInsee, moreResults, error, loading }
}

export default useListInsee
